import styled from 'styled-components'
import { Search } from 'react-feather'

export const SearchInputForm = styled.form`
  display: flex;
  align-items: center;
`

export const InputWrapper = styled.div`
 position: relative;
`

export const Input = styled.input`
  height: 2rem;
  box-sizing:border-box;
  border-radius: 0.5rem;
  border: 1px solid #002D62;
  padding: 0.5rem;
  padding-left: 1.8rem;
  margin-right: 1.5rem;
  width: 220px;
  font-family: Work Sans;
  font-style: normal;
  font-weight: 400;
  font-size: 1rem;
  outline: 0;
`

export const Icon = styled(Search)`
  position: absolute;
  box-sizing:border-box;
  height: 1rem;
  width: 1rem;
  margin-left: 0.3rem;
  top: 50%;
  transform: translateY(-50%);
`

export const Button = styled.button`
  border-radius: 8px;
  color: white;
  font-family: Work Sans;
  line-height: 19px;
  font-weight: bold;
  padding: 0.3rem 0.5rem;
  background-color: ${({ disabled, theme }) => (disabled ? '#bbbbbb' : theme.colors.blue)};
  font-size: 14px;
`
